/* eslint-disable no-restricted-imports */
import {
  Button as ButtonBase,
  type ButtonProps as ButtonPropsBase,
} from "@src/appV2/redesign/system/ui-components";
/* eslint-enable no-restricted-imports */
import { type LocationState } from "history";

import { ButtonInternalLink } from "./ButtonInternalLink";

export interface ButtonProps extends Omit<ButtonPropsBase, "LinkComponent"> {
  locationState?: LocationState;
  replace?: boolean;
}

export function Button(props: ButtonProps) {
  return <ButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
